<template>
    <div class="sidebar-favorites sidebar__responsive__element">
        <Tournaments
            :tournaments="sortedTournaments"
            @removeClick="onRemoveTournamentClick"
        />
    </div>
</template>

<script>
    import { orderBy as _orderBy } from '@lodash';
    import { mapGetters, mapActions } from 'vuex';
    import Tournaments from './components/Tournaments.vue';

    export default {
        name: 'FavouritesSidebarContainer',
        computed: {
            ...mapGetters('ui/user/preferences', [
                'tournaments',
                'tournamentsEvents',
            ]),
            sortedTournaments() {
                let lastIndex = 1;
                const tournamentsOrderMap = {};
                this.tournamentsEvents.forEach((match) => {
                    if (!tournamentsOrderMap[match.tournamentId]) {
                        tournamentsOrderMap[match.tournamentId] = lastIndex;
                        lastIndex += 1;
                    }
                });
                const filteredTournaments = this.tournaments.filter(({ id }) => tournamentsOrderMap[id]);
                return _orderBy(filteredTournaments, ({ id }) => tournamentsOrderMap[id]);
            }
        },
        methods: {
            ...mapActions('ui/user/preferences', [
                'removeTournament',
            ]),
            onRemoveTournamentClick(item) {
                this.removeTournament(item.id);
            },
        },
        components: {
            Tournaments
        }
    };
</script>


// WEBPACK FOOTER //
// src/app/modules/sportOffer/favourites/sidebar/FavouritesSidebarContainer.vue